import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

const useStyles = makeStyles((_theme) => ({
  paper: {
    flexGrow: 1,
    height: "100%",
    overflowX: "auto",
    padding: 48,
  },
}));

const Service = (_props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Fragment>
      <Paper className={classes.paper} elevation={0} square>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4">
            {t("Palvelusopimukset ja tietosuoja")}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid size="grow">
            <Box sx={{ mb: 2 }}>
              <Link to={"/dashboard/service/prices"}>{t("Hinnasto")}</Link>
            </Box>
            <Box sx={{ mb: 4 }}>
              <a href="https://opentaxi.fi/legal" target="_blank">
                {t("Käyttöehdot ja tietosuoja")}
              </a>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
};

export default Service;
